import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { consumePostLoginRedirect, exchangeCodeForTokens } from "../lib/auth";
import { useDocumentTitle } from "../hooks/use-document-title";

export function OAuthCallback() {
  useDocumentTitle("Signing in…");
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");

    if (!code) {
      setError("No authorization code received");
      return;
    }

    exchangeCodeForTokens(code)
      .then(() => {
        const target = consumePostLoginRedirect() ?? "/conversations";
        navigate(target, { replace: true });
      })
      .catch((err: unknown) => setError(err instanceof Error ? err.message : "Authentication failed"));
  }, [navigate]);

  if (error) {
    return (
      <div className="login-page">
        <div className="error-msg">{error}</div>
        <button className="btn" type="button" onClick={() => navigate("/login", { replace: true })}>
          Try again
        </button>
      </div>
    );
  }

  return (
    <div className="login-page">
      <p>Completing sign-in...</p>
    </div>
  );
}
